import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
type ProductPriceRangeProps = {
  className?: string;
  fromPrice: string;
  isOnSale?: boolean;
  toPrice: string;
};
export function ProductPriceRange(t0) {
  const $ = _c(14);
  const {
    className,
    fromPrice,
    isOnSale: t1,
    toPrice
  } = t0;
  const isOnSale = t1 === undefined ? false : t1;
  const priceLabel = isOnSale ? "Sale price" : "Price";
  let t2;
  if ($[0] !== className) {
    t2 = cn("sparky-c-price", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== fromPrice || $[3] !== priceLabel || $[4] !== toPrice) {
    t3 = <span className="visually-hidden">{priceLabel} range is {fromPrice} to {toPrice}</span>;
    $[2] = fromPrice;
    $[3] = priceLabel;
    $[4] = toPrice;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = isOnSale ? "sparky-c-price--sale" : "sparky-c-price";
  let t5;
  if ($[6] !== fromPrice || $[7] !== t4 || $[8] !== toPrice) {
    t5 = <span aria-hidden="true" className={t4}>{fromPrice} - {toPrice}</span>;
    $[6] = fromPrice;
    $[7] = t4;
    $[8] = toPrice;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t5) {
    t6 = <div className={t2}>{t3}{t5}</div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}